export enum CalendarZoom {
    Day = 'Day',
    Days = 'Days',
    Weeks = 'Weeks',
    Months = 'Months'
    // Quarters = 'Quarters'
}
